import { PaginateData, PaginateOptions } from './../utils/paginate.utils';
import { Injectable } from "@angular/core";
import { ApiService } from './api.service';
import { Observable, shareReplay } from 'rxjs';
import { CompetenciaInterface } from '../models/competencia.model';

@Injectable({
  providedIn: 'root'
})

export class CompetenciasService extends ApiService <CompetenciaInterface>{
  private maxEntries = 200;
  url = "competencias";

  getByTitulo = (paginateOptions: PaginateOptions, id: number, ignoreCache: boolean = false): Observable<PaginateData<CompetenciaInterface>> => {
    const cacheKey = `${JSON.stringify(paginateOptions)}_${id}`;
    if (this._getContent.size >= this.maxEntries) {
      const oldestKey = this._getContent.keys().next().value;
      if (typeof oldestKey === 'string') {
        this._getContent.delete(oldestKey);
      }
    }
    if (!this._getContent.get(cacheKey) || ignoreCache) {
      this._getContent.set(cacheKey,
        this.http.get(this.getApiUrl() + '/titulo/' + id, {
          params: {
            ...paginateOptions
          }
        }).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }

  asignarCompetencia = (data: any, titulo_id: number) => {
    return this.http.post(this.getApiUrl() + '/asignar-competencia/' + titulo_id, data);
  }

  getByDni = (paginateOptions: PaginateOptions,dni: number, ignoreCache = false) => {
    const cacheKey = `${JSON.stringify(paginateOptions)}-dni-${dni}`;
    if (ignoreCache) {
      this._getContent.delete(cacheKey);
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(this.getApiUrl() + '/por-dni/' + dni, {
          params: { ...paginateOptions,relations: 'materia,modalidad,nivel' }
        }).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }
  getCompetenciasAgrupadasByDni = (paginateOptions: PaginateOptions, dni: number , titulo_id: number) => {
    console.log("Obteniendo competencias agrupadas por DNI:", dni, "y título ID:", titulo_id);
    const cacheKey = `${JSON.stringify(paginateOptions)}_${dni}_${titulo_id}`;
    if (this._getContent.size >= this.maxEntries) {
      const oldestKey = this._getContent.keys().next().value;
      if (typeof oldestKey === 'string') {
        this._getContent.delete(oldestKey);
      }
    }
    if (!this._getContent.get(cacheKey)) {
      this._getContent.set(cacheKey,
        this.http.get(this.getApiUrl() + '/por-dni-agrupadas/' + dni + '/' + titulo_id, {
          params: {
            ...paginateOptions
          }
        }).pipe(shareReplay())
      );
    }
    return this._getContent.get(cacheKey)!;
  }
}
